/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { ColorSchemeName } from 'react-native';

import { AnimationsGallery } from './components/AnimationsGallery';
import { Badges } from './components/Badges';
import { Breakpoints } from './components/Breakpoints';
import { Buttons } from './components/Buttons';
import { CheckboxesAndRadios } from './components/CheckboxesAndRadios';
import { Colors } from './components/Colors';
import { Containers } from './components/Containers';
import { ControlledInputs } from './components/ControlledInputs';
import { DateSelections } from './components/DateSelections';
import { DropdownSelectors } from './components/DropdownSelectors';
import { GoalSetSections } from './components/GoalSetSections';
import { GuideBlurbs } from './components/GuideBlurbs';
import { Icons } from './components/Icons';
import { Inputs } from './components/Inputs';
import { MemberTips } from './components/MemberTips';
import { Navigation } from './components/Navigation';
import { NextActions } from './components/NextActions';
import { Notices } from './components/Notices';
import { PortalTestingGallery } from './components/PortalTestingGallery';
import { RowHeaders } from './components/RowHeaders';
import { RowLists } from './components/RowLists';
import { Rows } from './components/Rows';
import { SegmentedControlsAndSwitches } from './components/SegmentedControlsAndSwitches';
import { SelectMultipleExample } from './components/SelectMultiple';
import { SelectSingleExample } from './components/SelectSingle';
import { SelectTiles } from './components/SelectTiles';
import { SessionWidgets } from './components/SessionWidgets';
import { ShadowsGallery } from './components/ShadowsGallery';
import { Sheets } from './components/Sheets';
import { Sliders } from './components/Sliders';
import { Tiles } from './components/Tiles';
import { Toasts } from './components/Toasts';
import { Tooltips } from './components/Tooltips';
import { Typography } from './components/Typography';
import { WaitingAndLoading } from './components/WaitingAndLoading';
export type LightOrDarkTheme = Exclude<ColorSchemeName, null | undefined>;

export interface BlenderComponentDefinition {
    name: string;
    title: string;
    component: React.ComponentType<unknown>;
}

export const BlenderComponentMap: Record<string, BlenderComponentDefinition> = {
    Buttons: {
        name: 'Buttons',
        title: 'Buttons',
        component: Buttons,
    },
    AnimationsGallery: {
        name: 'AnimationsGallery',
        title: 'Animations',
        component: AnimationsGallery,
    },
    SegmentedControls: {
        name: 'SegmentedControls',
        title: 'Segmented Controls & Switches',
        component: SegmentedControlsAndSwitches,
    },
    Rows: {
        name: 'Rows',
        title: 'Rows',
        component: Rows,
    },
    Inputs: {
        name: 'Inputs',
        title: 'Inputs',
        component: Inputs,
    },
    ControlledInputs: {
        name: 'ControlledInputs',
        title: 'Inputs (Controlled)',
        component: ControlledInputs,
    },
    DateSelections: {
        name: 'DateSelections',
        title: 'Date Selection',
        component: DateSelections,
    },
    CheckboxesAndRadios: {
        name: 'CheckboxesAndRadios',
        title: 'Checkboxes & Radios',
        component: CheckboxesAndRadios,
    },
    Sliders: {
        name: 'Sliders',
        title: 'Sliders',
        component: Sliders,
    },
    SelectSingle: {
        name: 'SelectSingle',
        title: 'Selecting Single',
        component: SelectSingleExample,
    },
    SelectMultiple: {
        name: 'SelectMultiple',
        title: 'Selecting Multiple',
        component: SelectMultipleExample,
    },
    SelectTiles: {
        name: 'SelectTiles',
        title: 'Selectable Tiles',
        component: SelectTiles,
    },
    DropdownSelectors: {
        name: 'DropdownSelectors',
        title: 'Dropdown Selectors',
        component: DropdownSelectors,
    },
    Navigation: {
        name: 'Navigation',
        title: 'Navigation',
        component: Navigation,
    },
    Notices: {
        name: 'Notices',
        title: 'Notices',
        component: Notices,
    },
    GuideBlurbs: {
        name: 'GuideBlurbs',
        title: 'Guide Blurbs',
        component: GuideBlurbs,
    },
    NextActions: {
        name: 'NextActions',
        title: 'Next Actions',
        component: NextActions,
    },
    SessionWidgets: {
        name: 'SessionWidgets',
        title: 'Session Widgets',
        component: SessionWidgets,
    },
    RowHeaders: {
        name: 'RowHeaders',
        title: 'Row Headers',
        component: RowHeaders,
    },
    RowLists: {
        name: 'RowLists',
        title: 'Row Lists',
        component: RowLists,
    },
    Toasts: {
        name: 'Toasts',
        title: 'Toasts',
        component: Toasts,
    },
    Tooltips: {
        name: 'Tooltips',
        title: 'Tooltips',
        component: Tooltips,
    },
    WaitingAndLoading: {
        name: 'WaitingAndLoading',
        title: 'Waiting & Loading',
        component: WaitingAndLoading,
    },
    Badges: {
        name: 'Badges',
        title: 'Badges',
        component: Badges,
    },
    Icons: {
        name: 'Icons',
        title: 'Icons',
        component: Icons,
    },
    MemberTips: {
        name: 'MemberTips',
        title: 'Member Tips',
        component: MemberTips,
    },

    GoalSetSections: {
        name: 'GoalSetSections',
        title: 'Goal Set Sections',
        component: GoalSetSections,
    },
    Typography: {
        name: 'Typography',
        title: 'Typography',
        component: Typography,
    },
    Colors: {
        name: 'Colors',
        title: 'Colors',
        component: Colors,
    },
    Containers: {
        name: 'Containers',
        title: 'Containers',
        component: Containers,
    },
    Sheets: {
        name: 'Sheets',
        title: 'Sheets & Modals',
        component: Sheets,
    },
    ShadowsGallery: {
        name: 'ShadowsGallery',
        title: 'Shadows',
        component: ShadowsGallery,
    },
    Tiles: {
        name: 'Tiles',
        title: 'Tiles',
        component: Tiles,
    },
    Breakpoints: {
        name: 'Breakpoints',
        title: 'Breakpoints',
        component: Breakpoints,
    },
    PortalTestingGallery: {
        name: 'PortalTestingGallery',
        title: 'Portal testing',
        component: PortalTestingGallery,
    },
};

const Foundations: BlenderComponentDefinition[] = [
    BlenderComponentMap.Typography!,
    BlenderComponentMap.Colors!,
    BlenderComponentMap.Icons!,
    BlenderComponentMap.Breakpoints!,
    BlenderComponentMap.AnimationsGallery!,
    BlenderComponentMap.ShadowsGallery!,
];

const Testing: BlenderComponentDefinition[] = [
    BlenderComponentMap.PortalTestingGallery!,
];

const Components: BlenderComponentDefinition[] = Object.entries(
    BlenderComponentMap,
)
    .filter(
        ([, comp]) => !Foundations.includes(comp) && !Testing.includes(comp),
    )
    .map(([, comp]) => comp)
    .sort((a, b) => a.title.localeCompare(b.title));

export interface BlenderDirectoryCategory {
    category: string;
    entries: Array<BlenderComponentDefinition | undefined>;
}

export const BlenderDirectory: BlenderDirectoryCategory[] = [
    {
        category: 'Foundations',
        entries: Foundations,
    },
    {
        category: 'Components',
        entries: Components,
    },
    {
        category: 'Testing',
        entries: Testing,
    },
];
